import MultiPoseEdit from './MultiPoseEdit';

export default MultiPoseEdit;
